
import { AgentKnowledgeBase } from "@/components/candidates/types/agent";

// Knowledge bases for agent configuration
export const availableKnowledgeBases: AgentKnowledgeBase[] = [
  {
    id: "company-policies",
    name: "Company Policies",
    description: "Information about company policies and procedures",
    documentCount: 156,
    lastUpdated: new Date("2025-03-15"),
    isEnabled: true,
  },
  {
    id: "best-practices",
    name: "Best Practices",
    description: "Industry best practices and guidelines",
    documentCount: 89,
    lastUpdated: new Date("2025-04-01"),
    isEnabled: true,
  },
  {
    id: "recruiting-best-practices",
    name: "Recruiting Best Practices",
    description: "Best practices for recruiting and hiring",
    documentCount: 78,
    lastUpdated: new Date("2025-04-02"),
    isEnabled: true,
  },
  {
    id: "interview-questions",
    name: "Interview Questions",
    description: "Curated interview questions and evaluation criteria",
    documentCount: 234,
    lastUpdated: new Date("2025-04-05"),
    isEnabled: true,
  },
  {
    id: "email-templates",
    name: "Email Templates",
    description: "Professional email templates for various scenarios",
    documentCount: 67,
    lastUpdated: new Date("2025-04-03"),
    isEnabled: true,
  },
  {
    id: "client-management",
    name: "Client Management",
    description: "Client relationship management guidelines and procedures",
    documentCount: 123,
    lastUpdated: new Date("2025-04-04"),
    isEnabled: true,
  },
  {
    id: "scheduling-guidelines",
    name: "Scheduling Guidelines",
    description: "Best practices for scheduling and calendar management",
    documentCount: 45,
    lastUpdated: new Date("2025-04-06"),
    isEnabled: true,
  },
  {
    id: "market-data",
    name: "Market Data",
    description: "Industry market data and competitive intelligence",
    documentCount: 189,
    lastUpdated: new Date("2025-04-07"),
    isEnabled: true,
  },
  {
    id: "salary-benchmarks",
    name: "Salary Benchmarks",
    description: "Salary benchmarking data and negotiation guidelines",
    documentCount: 98,
    lastUpdated: new Date("2025-04-08"),
    isEnabled: true,
  }
];
